<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <mrc_ess_switch
          v-model="Positiondetails.is_used"
          v-if="$store.state.uuid"
          true-value="1"
          false-value="0"
          :readonly="readonly"
          :true-text="$t('label_To_enable_the')"
          :false-text="$t('label_disable')"
        ></mrc_ess_switch>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Position_Title') + '*'"
              :isNational="judegNational('job_post_name')"
              :readonly="readonly"
              :error-messages="
                $errors(
                  'Positiondetails',
                  'job_post_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="Positiondetails.job_post_name"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Short_code')"
              noRequired
              :isNational="judegNational('job_post_shortcode')"
              v-model="Positiondetails.job_post_shortcode"
              :error-messages="
                $errors('Positiondetails', 'job_post_shortcode', nocharacter)
              "
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- <mrc_ess_prompt :label="$t('label_Post_grades')+'*'"
                            :rules='false'
                            :disabled='readonly'
                            :multiple="true"
                            :errMsg="$errors(null,'jobPostRades',requiredRule)"
                            v-model="jobPostRades"
                            :obj="mrbase_sys_job_post_grades">
            </mrc_ess_prompt> -->
            <!-- <mrc_ess_prompt :label="$t('label_Post_grades') + '*'"
                            :rules="false"
                            :disabled="readonly"
                            :multiple="true"
                            :errMsg="$errors('Positiondetails', 'job_post_grades', requiredRule)"
                            v-model="Positiondetails.job_post_grades"
                            :obj="mrbase_sys_job_post_grades">
            </mrc_ess_prompt> -->
            <!-- :error-messages="
                $errors('Positiondetails', 'job_post_grades', requiredRule)
              " -->
            <mrc_ess_autoComplete
              :label="$t('label_Post_grades')"
              postGradesView
              multiple
              :readonly="readonly"
              v-model="Positiondetails.job_post_grades"
              :prompt_name="mrbase_sys_job_post_grades"
            ></mrc_ess_autoComplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- <mrc_ess_prompt :label="$t('label_department') + '*'"
                            :rules="false"
                            :disabled="readonly"
                            v-model="Positiondetails.dept_uuid"
                            :errMsg="$errors('Positiondetails', 'dept_uuid', requiredRule)"
                            :obj="companyName">
            </mrc_ess_prompt> -->
            <mrc_ess_autoComplete
              :label="$t('label_department')"
              :readonly="readonly"
              deptView
              v-model="Positiondetails.dept_uuid"
              :prompt_name="companyName"
            ></mrc_ess_autoComplete>
            <!--  
            2026-08-20 部门不必填
            :error-messages="
                $errors('Positiondetails', 'dept_uuid', requiredRule)
              " -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_describe')"
              noRequired
              :error-messages="
                $errors('Positiondetails', 'job_post_description', nocharacter)
              "
              :isNational="judegNational('job_post_description')"
              v-model="Positiondetails.job_post_description"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_NumInput
              :label="$t('label_The_sorting') + '*'"
              v-model="Positiondetails.sequence"
              :error-messages="
                $errors(
                  'Positiondetails',
                  'sequence',
                  between('000-999').concat(requiredRule)
                )
              "
              :readonly="readonly"
            ></mrc_ess_NumInput>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        :loading="btnIsLoading"
        @cancel="cancel"
        v-if="!readonly"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<style scoped>
.bt1 {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #ccc;
  line-height: 25px;
  text-align: center;
}
.sequenceinput {
  border-top: 1px black solid;
  border-bottom: 1px black solid;
  text-align: center;
}
</style>

<script>
import { getDetailsPost, updatePost, addPost } from "@/service/api/postmanagement.js";
import { getBusinessList } from "@/service/api/func_module.js";
import { required, maxLength, between, email, url } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    isreadonly: {
      type: Boolean,
    },
  },
  watch: {
    isreadonly(v) {
      this.readonly = v;
    },
  },
  validations: {
    Positiondetails: {
      job_post_name: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
        required,
      },
      job_post_shortcode: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      job_post_description: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      sequence: {
        between: between(0, 999),
        required,
      },
      job_post_grades: {
        // required,
      },
      // dept_uuid: {
      //   required,
      // },
    },
  },
  data() {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      nodorules: [
        (v) => !!v || "不能为空",
        (v) => String(v).length <= 200 || "超过输入个数",
        (v) => !/[@#$%^&()<>?/]/.test(v) || "请勿输入非法字符",
        (v) => !/^ +| +$/g.test(v) || "不能输入空格",
      ],
      userrules: [
        (v) => String(v).length <= 20 || "超过输入个数",
        (v) => !/[^\w]/g.test(v) || "只能输入数字和字母",
      ],
      // company_uuid: '',  //当前公司uuid
      switch1: false,
      readonly: this.isreadonly,
      items: ["foo", "bar", "fizz", "buzz"],
      value: ["foo", "bar", "fizz", "buzz"],
      addsequence: 1,
      Positiondetails: {
        created_by: "", //创建人
        created_utc_datetime: "", //创建时间
        job_post_shortcode: "", //短编码 暂时后端无该字段
        dept_uuid: "", //部门uuid
        is_used: "1", //是否启用 0 否 1 是
        job_post_description: "", //岗位描述
        job_post_grades: "", //岗位级别 多个用逗号分隔
        job_post_id: "",
        job_post_name: "", //岗位名称
        org_level_uuid: "", //公司uuid
        sequence: "", //排序
        updated_by: "", //更新人
        updated_utc_datetime: "",
        uuid: "",
      },
    };
  },
  created() {},
  async mounted() {
    this.national("mrbase_sys_job_posts");
    if (this.$store.state.uuid) {
      await this.getlist();
    } else {
    }
  },
  methods: {
    async getlist() {
      this.skeletonloading = true;
      const res = await getDetailsPost({
        uuid: this.$store.state.uuid,
      });
      this.Positiondetails = res.data; //渲染页面
      // this.Positiondetails.is_used == 1 ? this.Positiondetails.is_used = true : this.Positiondetails.is_used = false
      // this.Positiondetails.job_post_grades =
      //   this.Positiondetails.job_post_grades == ''
      //     ? []
      //     : this.Positiondetails.job_post_grades.split(',')
      this.skeletonloading = false;
    },
    async success() {
      //提交
      this.$v.Positiondetails.$touch();
      this.$v.$touch();
      if (this.$v.Positiondetails.$error) return;
      this.btnIsLoading = true;
      // this.Positiondetails.job_post_grades = this.Positiondetails.job_post_grades.join()
      const Positiondetails = this.Positiondetails;
      delete Positiondetails.created_by;
      delete Positiondetails.created_utc_datetime;
      delete Positiondetails.job_post_id;
      delete Positiondetails.updated_by;
      delete Positiondetails.updated_utc_datetime;
      if (this.$store.state.uuid) {
        Positiondetails.org_level_uuid = this.company_uuid;
        const res = await updatePost(Positiondetails);
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          this.getlist();
          this.$emit("changeReadonly");
        } else if (res.code == 7013) {
          this.$myConfirm({
            content: this.$t("message_Subordinate_employees_cannot_modify_the_position"),
          });
        } else {
          this.$myConfirm({
            content: this.$t("message_The_modification_failed"),
          });
        }
        this.btnIsLoading = false;
      } else {
        Positiondetails.org_level_uuid = this.company_uuid;
        const res = await addPost(Positiondetails);
        if (res.code == 200) {
          this.$router.push({
            name: "jobs_manage",
          });
        }
        this.btnIsLoading = false;
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getlist();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.push({
              name: "jobs_manage",
            });
          })
          .catch((err) => {});
      }
      //取消
    },
  },
  computed: {
    company_uuid() {
      return this.$store.state.currentCompany;
    },
    companyName() {
      // return { prompt_name: 'mrbase_sys_level_company_relevance_dept', company_uuid: this.company_uuid }
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.company_uuid,
      };
    },
    mrbase_sys_job_post_grades() {
      return {
        prompt_name: "mrbase_sys_job_post_grade",
        org_level_uuid: this.company_uuid,
      };
    },
  },
};
</script>

<style scoped></style>
